import React from 'react';
import SinglePagePortfolio from './components/SinglePagePortfolio';

const App = () => {
  return <SinglePagePortfolio />;
};

export default App;
